/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { NgModule } from '@angular/core';

import '@gh/builder-shared/mls/builder.mls.json';

import { CoreMlsModule, JSONTranslationMapLoader, provideTranslationMapLoader } from '@gh/core-mls';

@NgModule({
  imports: [
    CoreMlsModule.forRoot(),
  ],
  providers: [
    provideTranslationMapLoader(JSONTranslationMapLoader),
  ],
  exports: [
    CoreMlsModule,
  ],
})
export class BuilderMlsConfigModule {

}
